import { ca } from '@cian/analytics';
import { sendTeaserEvent } from '../../services/teaser';

export function trackRealtorBannerClick() {
  const page = window && window.CianAnalytics ? window.CianAnalytics.service.config.page : {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Banner',
    page: {
      ...page,
      extra: {
        banner_location: 'header',
      },
    },
  });
}

export function trackRealtorBannerShown() {
  sendTeaserEvent([
    {
      block_type: 'demand',
      isTeaserShow: true,
      demand_location: 'header',
    },
  ]);
}
